import React from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import styles from "./Navbar.module.css";
import logo from "../../assets/logo.png";
import { useNavbar } from "../../customHooks/Navbar/useNavbar";
import { AiOutlineLogout } from "react-icons/ai";
import { useIsAuthorized } from "../../customHooks/Authorization/useAuthorization";

const NavBar = () => {
  const location = useLocation();
  const {
    handleLogout,
    toggleDropdown,
    closeDropdowns,
    issuesDropdownRef,
    logsDropdownRef,
    dropdownsContainerRef,
    environments,
    clients,
    handleSelection,
    userData,
    rootClient,
    rootEnvironment,
    getCurrentClientName,
    isAdmin
  } = useNavbar();

  return (
    <div className={styles.NavbarRoot}>
      <div className={styles.VerticalNav} ref={dropdownsContainerRef}>
        <div className="container">
          <div className="d-flex align-items-center justify-content-between mb-0">
            <div className="">
              <div className={styles.NavbarExpand}>
                <Link to="/" className={styles.NavbarBrand}>
                  <img
                    className={styles.SkyWorthLogo}
                    src={logo}
                    alt="logo"
                    width={180}
                  />
                </Link>
              </div>
            </div>
            <div className="">
              <ul className={styles.SideMenu}>
                <NavLink
                  to="/transaction-logs"
                  className={styles.SideMenuItemLink}
                >
                  <li>Transaction Logs</li>
                </NavLink>

                <NavLink to="/storeqc" className={styles.SideMenuItemLink}>
                  <li>Qc</li>
                </NavLink>
              </ul>
            </div>
            <div className={styles.NavbarRightOptions}>
              {isAdmin ? (
                <div>
                  <select
                    id="status"
                    className="form-select"
                    aria-label="Default select example"
                    onChange={(e) => handleSelection(e.target.value, "client")}
                    value={rootClient}
                  >
                    {clients.map((client) => {
                      return (
                        <option value={client._id}>{client.client_name}</option>
                      );
                    })}
                  </select>
                </div>
              ) : (
                <div className={styles.clientName}>
                  <strong>{getCurrentClientName()}</strong>
                </div>
              )}
              <div>
                <select
                  id="status"
                  className="form-select"
                  aria-label="Default select example"
                  onChange={(e) =>
                    handleSelection(e.target.value, "environment")
                  }
                  value={rootEnvironment}
                >
                  {environments.map((environment) => {
                    return (
                      <option value={environment._id}>
                        {environment.environment}
                      </option>
                    );
                  })}
                </select>
              </div>

              <ul className={styles.SideMenu}>
                <li className={styles.SideMenuItem}>
                  <Link
                    onClick={handleLogout}
                    to={location.pathname}
                    className={styles.SideMenuItemLink}
                  >
                    <AiOutlineLogout size={25} />
                    Logout
                  </Link>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NavBar;
